// extracted by mini-css-extract-plugin
export default {"organizationImage":"CreateLandlordAddOrganizationLogo_organizationImage__zHAES"};